import React, { useState, useEffect, useMemo } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Paginator } from "primereact/paginator";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Dropdown } from 'primereact/dropdown';
import { FilterTypes } from "../enums/TableTypes";
import Loading from "../Ui/Loading";

type props = {
    data: any[];
    columns: {
        name?: string,
        title: any,
        body?: (rowData) => any,
        class?: string, colWidth?: string,
        filter?: {
            init: boolean,
            type?: FilterTypes,
            options?: { label: string, value: any }[],
            placeholder?: string;
        }
    }[];
    rowClassName?: any;
}

const Table = ({ data, columns, rowClassName }: props) => {
    const [tableData, setTableData] = useState([]);
    const [tableColumns, setTableColumns] = useState<typeof columns>([]);

    const filters = useMemo(() => {
        if (!columns) return;
        let fil = {};
        Object.values(columns).map(i => {
            if (i?.filter?.init) {
                fil[i.name] = {
                    value: null,
                    matchMode: i.filter.type === FilterTypes.dropDown
                        ? FilterMatchMode.EQUALS
                        : FilterMatchMode.CONTAINS
                }
            }
        });

        return fil;
    }, columns);


    const getDropDown = (options, name, placeholder?) => (
        <Dropdown
            value={options.value}
            options={tableColumns.find(col => col.name === name).filter.options}
            onChange={(e) => {
                options.filterApplyCallback(e.value !== null ? Number(e.value) : null);
            }}
            placeholder={placeholder}
            showClear
        />
    )

    useEffect(() => {
        setTableData(data);
        setTableColumns(columns);
    }, [columns, data])

    return (

        !data && !columns ? (
            <Loading />
        ) : (
            <DataTable
                value={tableData}
                className="tableD"
                emptyMessage="Здесь пусто"
                paginator
                rows={6}

                rowClassName={rowClassName}

                filters={filters}
                filterDisplay={Object.keys(filters).length !== 0 ? "row" : undefined}
            >
                {tableColumns.map(item => (
                    item.filter?.init ? (
                        <Column
                            headerClassName={item.class || ""}
                            style={{ minWidth: item.colWidth || "" }}
                            field={item.name && item.name}
                            header={item.title}
                            body={item.body && item.body}

                            filter={item.filter.init}
                            filterField={item.filter.type != FilterTypes.dropDown && item.name}
                            filterElement={item.filter.type === FilterTypes.dropDown && ((options) => getDropDown(options, item.name, item.filter?.placeholder))}
                            showFilterMenu={false}
                            key={item.name}
                        />
                    ) : (
                        <Column
                            headerClassName={item.class || ""}
                            style={{ minWidth: item.colWidth || "" }}
                            field={item.name && item.name}
                            header={item.title}
                            body={item.body && item.body}
                            key={item.name}
                        />
                    )
                ))}
            </DataTable>
        )

    )
}

export default Table;